import React from 'react'

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import eli2 from "../assets/img/eli2.png";
import webbg from "../assets/img/webbg.png";
import webbg2 from "../assets/img/webbg2.png";
// import webbg2 from "../assets/img/webbg2.png";
import g1 from "../assets/img/g1.jpg";
import g2 from "../assets/img/g2.jpg";
import g3 from "../assets/img/g3.jpg";
import g4 from "../assets/img/g4.jpg";
import g5 from "../assets/img/g5.jpg";
import g6 from "../assets/img/g6.jpg";
import op9 from "../assets/img/op9.png";
import op10 from "../assets/img/op10.png";
import op11 from "../assets/img/op11.png";
import op12 from "../assets/img/op12.png";
import op13 from "../assets/img/op13.png";
import op14 from "../assets/img/op14.png";
import op15 from "../assets/img/op15.png";
import op16 from "../assets/img/op16.png";
import joinbutton from "../assets/img/joinbutton.png";
import about_us1 from "../assets/img/about-us1.jpg";
import about_us2 from "../assets/img/about-us2.jpg";
import staranimate from "../assets/img/staranimate.png";
import { Link } from 'react-router-dom';


import { Helmet } from "react-helmet-async";


export default function About() {
    const settings3 = {
    dots: false,          // neeche dots nahi chahiye
    infinite: true,       // loop hoga
    speed: 500,           // transition speed
    slidesToShow: 4,      // ek time me kitne images show hongi
    slidesToScroll: 1,    // ek bar me kitne scroll honge
    autoplay: true,       // auto scroll
    autoplaySpeed: 2000,  // 2 sec delay
    arrows: false,        // arrows hide
    responsive: [
      {
        breakpoint: 1024,
        settings3: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 768,
        settings3: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 480,
        settings3: {
          slidesToShow: 2,
        }
      }
    ]
  };
  return (
    <>

	 <Helmet>
        <title>About Us | StockCod - Top Web Development Company</title>
        <meta name="description" content="Contact StockCod for expert website development services in Ghaziabad. Our team is ready to assist you with any inquiries." />
      </Helmet>
        <section className="inntepagesection">
            <div className="outerofinnterpage" 
            style={{
                backgroundImage: `url(${webbg})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                }}
                >
                <div className="background-overlay overlay-about-bnr"></div>
                <div className="container">
                    <div className="innerpagecontent">
                        <div className="staranimate">
                            <img src={staranimate} alt='star icon' />
                        </div>
                        <h2>About Us</h2>
                        <ul>
                            <li>
                                <Link to="/">Home <span>..</span></Link>
                            </li>
                            <li>
                                <Link to="/about-us">About Us</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>

<section className="sectionpadding" 
style={{
    backgroundImage: `url(${webbg2})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
}}
>
		<div className="background-overlay overlay-about-us"></div>
		<div className="overlayset2 about-us-page" 
        style={{
            backgroundImage: `url(${eli2})`,
            }}
            >
				</div>
		<div className="outerofabout">
			<div className="container">
				<div className="row">
					<div className="col-lg-6 col-md-12 col-sm-12">
						<div className="aboutcontent">
							<div className="sectionheading">
								<h2>Grow Your Business With <span>StockCod</span></h2>
							</div>
							<div className="imgofabout-us">
								<img src={about_us1} alt="about us" />
							</div>
						</div>
					</div>
					<div className="col-lg-6 col-md-12 col-sm-12">
						<div className="aboutcontent-two">
							<p>Welcome to Stock Cod, a leading digital agency and Best website development company in Ghaziabad with a decade of experience. We are committed to delivering exceptional and successful digital marketing solutions to enhance your brand's visibility, online presence, and insights. Trust us to take your business to new heights with our cutting-edge strategies and unmatched expertise.</p>
							<div className="webbtn-contact">
								<a href="contact-us">Get Started <i className="fa fa-long-arrow-right" aria-hidden="true"></i></a>
							</div>
						</div>
						<div className="imgofabout-us">
							<img src={about_us2} alt='about tow' />
						</div>
					</div>
				</div>
			</div>
		</div>
		<div className="outerofcounterdown about-us-counter">
			<div className="count-area" data-diff="100">
			    <div className="container">
			        <div className="row">
			            <div className="col-sm-6 col-md-3 achivmentouterbox">
			                <div className="count-area-content">
			                	<div className="counterbox">
				                    <div className="count-digit">2</div>
				                    <span>+</span>
				                </div>
			                    <div className="count-title">Year of Experience</div>
			                </div>
			            </div>
			            <div className="col-sm-6 col-md-3 achivmentouterbox">
			                <div className="count-area-content">
			                	<div className="counterbox">
				                    <div className="count-digit">80</div>
				                    <span>+</span>
				                </div>
			                    <div className="count-title">Happy Client</div>
			                </div>
			            </div>
			            <div className="col-sm-6 col-md-3 achivmentouterbox">
			                <div className="count-area-content">
			                	<div className="counterbox">
				                    <div className="count-digit">150</div>
				                    <span>+</span>
				                </div>
			                    <div className="count-title">Complete Project</div>
			                </div>
			            </div>
			            <div className="col-sm-6 col-md-3 achivmentouterbox">
			                <div className="count-area-content">
			                	<div className="counterbox">
				                    <div className="count-digit">10</div>
				                    <span>+</span>
				                </div>
			                    <div className="count-title">Team Members</div>
			                </div>
			            </div>
			        </div>
			    </div>
			  </div>
		</div>
	    </section>
	<section className="gallerysection">
		<div className="outerofgallery">
			<div className="owlslider">
                <Slider {...settings3}>
                    <div className="gallerybox">
                        <img src={g1} alt="stockcod" />
                    </div>
                    <div className="gallerybox">
                        <img src={g2} alt="stockcod" />
                    </div>
                    <div className="gallerybox">
                        <img src={g3} alt="stockcod" />
                    </div>
                    <div className="gallerybox">
                        <img src={g4} alt="stockcod" />
                    </div>
                    <div className="gallerybox">
                        <img src={g5} alt="stockcod" />
                    </div>
                    <div className="gallerybox">
                        <img src={g6} alt="stockcod" />
                    </div>
                </Slider>
			</div>
		</div>
	</section>
	<section className="sectionpadding" 
    style={{
        backgroundImage: `url(${webbg2})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
    }}
    >
		<div className="background-overlay overlay-about-us"></div>
		<div className="outerofourpartern_about_us_page">
			<div className="container">
				<div className="sectionheading">
					<h2>Our <span>Partner</span></h2>
					<p>Our valued partners fuel our success. Together, we achieve greatness in the digital landscape.</p>
				</div>
				<div className="row">
					<div className="col-lg-3 col-md-4 col-md-6 col-xs-6">
						<div className="partnerlogo">
							<img src={op9} alt='' />
						</div>
					</div>
					<div className="col-lg-3 col-md-4 col-md-6 col-xs-6">
						<div className="partnerlogo">
							<img src={op10} alt='' />
						</div>
					</div>
					<div className="col-lg-3 col-md-4 col-md-6 col-xs-6">
						<div className="partnerlogo">
							<img src={op11} alt='' />
						</div>
					</div>
					<div className="col-lg-3 col-md-4 col-md-6 col-xs-6">
						<div className="partnerlogo">
							<img src={op12} alt='' />
						</div>
					</div>
					<div className="col-lg-3 col-md-4 col-md-6 col-xs-6">
						<div className="partnerlogo">
							<img src={op13} alt='' />
						</div>
					</div>
					<div className="col-lg-3 col-md-4 col-md-6 col-xs-6">
						<div className="partnerlogo">
							<img src={op14} alt='' />
						</div>
					</div>
					<div className="col-lg-3 col-md-4 col-md-6 col-xs-6">
						<div className="partnerlogo">
							<img src={op15} alt='' />
						</div>
					</div>
					<div className="col-lg-3 col-md-4 col-md-6 col-xs-6">
						<div className="partnerlogo">
							<img src={op16} alt='' />
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
	<section className="sectionpadding" style={{
        background: `url(${webbg2})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
    }}>
		<div className="background-overlay overlay-about-us"></div>
		<div className="outerofcalltoactionjoin">
			<div className="container">
				<div className="row">
					<div className="col-xl-8 col-lg-8 col-md-6 col-sm-12">
						<div className="joinuscontent">
							<div className="sectionheading">
								<h2>Want to join?</h2>
							</div>
							<p>Find a team of digital marketers you can rely on. Every day, we build trust through communication, transparency, and results.</p>
						</div>
					</div>
					<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
						<div className="joinbutton">
							<div className="joinbuttonimg">
								<img src={joinbutton} alt='' />
							</div>
							<div className="webbtn">
								<Link to="/contact-us">Get Started</Link>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section> 
    </>
  )
}
